import styled from 'styled-components';

export const StyledContainer = styled.div`

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    .display {
      display: flex;
    }
    .display-footer {
      display: block;
    } 
    .hidden {
      display: none;
    }
    .display-mobile-container {
      height: auto;
    }
  }
`;

export const LiveContainer = styled.div`
  display: flex;
  padding: 32px 106px;
  gap: 16px;
  min-width: 100%;
  max-width: 100%;
  height: calc(66.5vh + 54px + 16px);


  > div:first-child {
    min-width: 60%;
  }
  
  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    height: 100%;
    > div:first-child {
      > div:first-child {
        height: 30vh;
      }
    }
  }

  >iframe {
      border: none;
      border-radius: 8px;
  }

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    flex-wrap: wrap;
    padding: 0;
  }

  background: ${(props) => props.theme.colors.background};
`;

export const LiveInfos = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 106px 64px 106px; 
  gap: 16px;
  
  >div {
    display: flex;
    gap: 24px;
    align-items: center;
    margin-bottom: 32px;

    ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
      flex-wrap: wrap;  
      justify-content: start;
      text-align: justify;
      padding: 0;
    }
  }

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    flex-wrap: wrap;  
    justify-content: center;
    padding: 32px 16px;
  }

  background: ${(props) => props.theme.colors.background};
`;

export const ShareTransmission = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 32px 298px 32px 298px;

  .share-icons-container {
    width: 100%;
    justify-content: center;
  }
  
  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    flex-wrap: wrap;  
    justify-content: center;
    gap: 32px;
    padding: 32px 16px;
  }
`;

export const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;

  iframe {
    border: 1px solid ${(props) => props.theme.colors.line};
    flex: 1;
  }

  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
      width: 100%;
      
      iframe{
        margin-top: 8px;
        border: none;
        border-radius: 0;
        min-height: 54vh;
      }

      .display-mobile {
        height: auto;
      }
    }

  
  .buttons-container {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    padding-left: 8px;

    .down-up-button {
      margin-left: auto;
      margin-right: 16px;
      display: none;
    }

    .down-up-button:hover{
      cursor: pointer;
    }

    ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
      .down-up-button {
        display: block;
      }
    }
  }

  .transition {
    transition: transform 0.25s linear;
  }

  .animate-down {
    transform: rotate(180deg);
  }

  .animate-up {
    transform: rotate(0deg);
  }

`;

export const Row = styled.div`
  display: flex;
`;

export const DateAndHour = styled.span`
  color: ${(props) => props.theme.colors.label};
  display: flex;

  ${(props) => props.theme?.mediaQuerie.maxWidth.sm}{
    font-size: 12px;
  }
`;

export const Dot = styled.div`
  align-self: center;
  height: 4px;
  width: 4px;
  background-color: ${(props) => props.theme.colors.label};
  border-radius: 50%;
  margin: 0 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 16px;
  margin-top: 40px;
    
  ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
    margin: 10px;
  }

  >div{
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 40px;
  }
  `;
  
  export const DisplayMore = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    overflow-y: scroll;
    background: ${(props) => props.theme.colors.white};
    padding: 16px;
    height: 100%;

    ${(props) => props.theme?.mediaQuerie.maxWidth.md}{
      width: 100vw;
      gap: 32px;
      overflow-y: scroll;
      height: 50vh;
    }
     /* width */
    ::-webkit-scrollbar {
      width: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.inputBackground};
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: ${(props) => props.theme.colors.placeholder};
      border-radius: 8px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: ${(props) => props.theme.colors.label};
    } 
  `;

export const MaterialsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  margin-top: 16px;
  width: 100%;

  ${(props) => props.theme.mediaQuerie.maxWidth.sm}{
    width: 100%;

    .break-text {
      word-break: break-all;
    }
  }

  >a{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 16px;

    &:hover{
      cursor: pointer;
    }
    
    .break-text {
      margin: 0 auto 0 0;
      word-break: break-word;
    }

    .icon-container {
      padding: 8px 12px;
      border-radius: 6px; 
      background-color: ${(props) => props.theme.colors.inputBackground};
    }
  }
`;